import styles from './Footer.module.css';
import { Link } from 'react-router-dom';

// Images
import logo from '../../images/logo.png';

export default function Footer() {
  return (
    <div className={styles.container}>
      <div className={styles.infoContainer}>
        <div className={styles.infoDesc}>
            <div>
              <img className={styles.logo} src={logo} />
              <p className={styles.name}>Andrea Wong</p>
            </div>
            <div className={styles.contactContainer}>
              <p className={styles.contactTitle}>Contact</p>
              <div className={styles.contactInfo}>
                <i class="fa fa-envelope-o"></i>
                <button onClick={() => window.location = 'mailto:andrea.wzg@gmail.com'}>andrea.wzg@gmail.com</button>
              </div>
              <div className={styles.contactInfo}>
                <i class="fa fa-linkedin-square"></i>
                <a className={styles.socialIcon} href="https://www.linkedin.com/in/andreawzg/" target="_blank">linkedin.com/in/andreawzg</a>
              </div>
              <div className={styles.contactInfo}>
                <i class="fa fa-github"></i>
                <a className={styles.socialIcon} href="https://github.com/Andreawz3" target="_blank">github.com/Andreawz3</a>
              </div>
            </div>
        </div>
        <p className={styles.copyRight}>© 2025 Andrea Wong</p>
      </div>
    </div>
  )
}